import React, {useEffect, useState} from 'react';
import EntityFormProp from './properties/entity-form';
import {EntityTypeEnum} from '../enums/EntityTypeEnum';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function EntityForm({
  entity, setStatusMessage, removeEntity, onChange,
}: EntityFormProp): React.ReactElement {
  const [data, setData] = useState(entity);

  useEffect(() => {
    setStatusMessage('', StatusMessageTypeEnum.none);
    onChange(data);
  }, [data]);

  return (
    <div className="ps-0 pt-2 loading-wrapper">
      <div className="row">
        <div className="col-md-12 mb-1">
          <div className="row">
            <div className="col  mb-1">
              <input
                type="text"
                id="searchRef"
                className="form-control"
                placeholder="Search Ref"
                value={data.searchRef.trim()}
                onChange={(e) => setData((prevState) => ({
                  ...prevState, searchRef: e.target.value,
                }))}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-1">
              <input
                type="text"
                id="isA"
                className="form-control"
                placeholder="Is A"
                value={data.verb}
                onChange={(e) => setData((prevState) => ({
                  ...prevState, verb: e.target.value,
                }))}
              />
            </div>
            <div className="col-md-6 mb-1">
              <input
                type="text"
                id="containedInFile"
                className="form-control"
                placeholder="Contained In File"
                value={data.target}
                onChange={(e) => setData((prevState) => ({
                  ...prevState, target: e.target.value,
                }))}
              />
            </div>
          </div>

          {
            data.type !== EntityTypeEnum.main ? (
              <div className="row">
                <div className="col mb-1">
                  <input
                    type="text"
                    id="connectingVerb"
                    className="form-control"
                    placeholder="Connecting Verb"
                    value={data.connectingVerb}
                    onChange={(e) => setData((prevState) => ({
                      ...prevState, connectingVerb: e.target.value,
                    }))}
                  />
                </div>
                <div className="col mb-1">
                  <button
                    type="submit"
                    className="btn btn-light col-12"
                    onClick={() => {
                      removeEntity(entity);
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ) : ''
          }
        </div>
      </div>
    </div>
  );
}

export default EntityForm;
